import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Article, resolveStrapiMediaUrl } from '../services/api';
import colors from '../theme/colors';

const CardContainer = styled(Link)`
  display: block;
  background: ${colors.mainWhite};
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(30, 30, 30, 0.1);
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border: 1px solid ${colors.goldGrey};
  text-decoration: none;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 4px 16px rgba(255, 86, 30, 0.2);
    border-color: ${colors.mainOrange};
    text-decoration: none;
  }
`;

const CardImage = styled.div<{ $imageUrl?: string }>`
  height: 200px;
  background-image: url(${props => props.$imageUrl || '/api/placeholder/400/200'});
  background-size: cover;
  background-position: center;
  background-color: ${colors.goldGrey};
`;

const CardContent = styled.div`
  padding: 1.5rem;
`;

const CardTitle = styled.h3`
  margin: 0 0 0.5rem 0;
  font-size: 1.25rem;
  font-weight: 600;
  letter-spacing: -0.01em;
  line-height: 1.35;
  color: ${colors.mainBlack};
`;

const CardDescription = styled.p`
  margin: 0 0 0.75rem 0;
  color: ${colors.textGray};
  font-size: 0.9375rem;
  line-height: 1.5;
`;

const CardMeta = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.8rem;
  color: ${colors.heavyGray};
  margin-bottom: 1rem;
`;

const CardAuthor = styled.span`
  font-weight: 500;
  color: ${colors.mainBlack};
`;

const CardDate = styled.span`
  color: ${colors.heavyGray};
`;

interface ArticleCardProps {
  article: Article;
}

const ArticleCard: React.FC<ArticleCardProps> = ({ article }) => {
  // Strapi 5: дані без attributes обгортки
  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString('uk-UA', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  const getImageUrl = () => {
    if (article.cover?.url) {
      return resolveStrapiMediaUrl(article.cover.url);
    }
    return undefined;
  };

  // Використовуємо id як fallback, якщо slug відсутній
  const articleSlug = article.slug || article.id?.toString() || 'no-slug';

  return (
    <CardContainer to={`/article/${articleSlug}`} aria-label={article.title || 'Перейти до статті'}>
      <CardImage $imageUrl={getImageUrl()} />
      <CardContent>
        <CardTitle>{article.title || 'Без назви'}</CardTitle>
        <CardDescription>{article.description || 'Опис відсутній'}</CardDescription>
        <CardMeta>
          <CardAuthor>
            {article.author?.name || 'Невідомий автор'}
          </CardAuthor>
          <CardDate>{article.publishedAt ? formatDate(article.publishedAt) : 'Без дати'}</CardDate>
        </CardMeta>
      </CardContent>
    </CardContainer>
  );
};

export default ArticleCard;
